import { AfterViewInit, ChangeDetectionStrategy, Component, computed, DestroyRef, effect, inject, OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { CountableTimeZonePipe } from 'countable@helpers';
import { ClassNamesScheduleModel, EngagementScheduleModel, InputOutputEmitter, TitleIconScheduleModel } from 'countable@model';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { CanComponentDeactivate } from '../../../../can-deactivate.guard';
import { ScheduleService } from '../../../../services/schedule.service';
import { PreviewScheduleComponent } from '../../../remote-shared/schedules/preview-schedule/preview-schedule.component';
import { ViewScheduleComponent } from './view-schedule/view-schedule.component';
import {finalize} from "rxjs/operators";

@Component({
  selector: 'app-working-schedules',
  imports: [ViewScheduleComponent, MatButtonModule, MatSidenavModule, PreviewScheduleComponent, CountableTimeZonePipe],
  templateUrl: './working-schedules.component.html',
  styleUrl: './working-schedules.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WorkingSchedulesComponent implements OnInit , AfterViewInit , CanComponentDeactivate {
  @ViewChild('drawer') drawer: MatDrawer;
  public viewId: WritableSignal<string> = signal<string>(null);
  public engagementScheduleDetails: WritableSignal<EngagementScheduleModel> = signal<EngagementScheduleModel>(new EngagementScheduleModel());
  public scheduleName: WritableSignal<string> = signal<string>('');
  public isSyncCall: WritableSignal<boolean> = signal<boolean>(false);
  private destroyRef = inject(DestroyRef);

  constructor(private activatedRoute: ActivatedRoute, private scheduleService: ScheduleService,
              private countableTimeZonePipe: CountableTimeZonePipe, public toasterService: ToastrService) {
    effect(() => {
      this.engagementScheduleDetails.set(this.scheduleService.engagementScheduleSignal());
      if (this.engagementScheduleDetails().schedulesData?.schedules?.length && this.engagementScheduleDetails().schedulesData?.schedules.filter((s: any) => s.uuid === this.viewId()).length) {
        const selectedSchedule = this.engagementScheduleDetails().schedulesData?.schedules.filter((s: any) => s.uuid === this.viewId())[0];
        this.scheduleName.set(`Schedule ${selectedSchedule.sortOrder} - ${selectedSchedule.nameChange ? selectedSchedule.nameChange : selectedSchedule.name }`);
      }
    });
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(param => {
      if(param?.NoteId){
        this.viewId.set(param?.NoteId ? param?.NoteId : null);
      }
    });

    this.scheduleService.syncCallSpinner$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(value=>{
      this.isSyncCall.set(value);
    });
  }

  ngAfterViewInit() {
    this.drawer.open();
  }

  updateSyncCall(event){
    this.isSyncCall.set(event);
  }

  manualSync(){
    this.scheduleService.manualSync.next(true);
  }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    return this.scheduleService.saveChanges.getValue();
  }
}
